import { getOptimizedPoints } from './routes'

export async function getTSPWay (dataSelectedPoints = []) {
  const atsp = new ATSP()

  atsp.selectedPoints = [...dataSelectedPoints]

  let res = await atsp
    .mainAsymmetricTSPByCoordinates()
    .then(result => {
      return result
      //   console.log('=== РЕЗУЛЬТАТЫ РАСЧЕТА TSP ===')
      //   console.log(`Всего итераций: ${result.iterations.length}`)
      //   console.log(`Всего запросов к API: ${result.totalRequests}`)
      //   console.log('')

      //   // Вывод лучшего результата
      //   if (result.bestResult) {
      //     console.log('=== ЛУЧШИЙ РЕЗУЛЬТАТ ===')
      //     console.log(`Метод: ${result.bestResult.method}`)
      //     console.log(`Расстояние: ${result.bestResult.distance} м`)
      //     //console.log(`Время вычисления: ${result.bestResult.time?.toFixed(2) || 'N/A'} мс`)
      //     console.log(`Маршрут: ${result.bestResult.path.join(' → ')}`)
      //     console.log('')
      //   }
    })
    .catch(error => {
      console.error('Ошибка при расчете TSP:', error)
      console.error('Стек вызовов:', error.stack)
    })

  return res
}

class ATSP {
  selectedPoints = []

  constructor () {}

  prepareWaypoints (waypoints) {
    return waypoints
      .map(element => {
        return [...element['coordinates']].reverse().join(',')
      })
      .join('|')
  }

  haversineDistanceM (lat1, lon1, lat2, lon2) {
    const R = 6371 // Радиус Земли в километрах
    const toRadians = degree => degree * (Math.PI / 180)

    const dLat = toRadians(lat2 - lat1)
    const dLon = toRadians(lon2 - lon1)

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) *
        Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2)

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

    const distance = R * c // Расстояние в километрах
    const distanceM = Math.round(distance * 1000) // Расстояние в метрах
    return distanceM
  }

  createDistanceMatrix (selectedPoints) {
    const n = selectedPoints.length
    const matrix = new Array(n)

    // Инициализация матрицы
    for (let i = 0; i < n; i++) {
      matrix[i] = new Array(n)
    }

    // Заполнение матрицы расстояниями
    for (let i = 0; i < n; i++) {
      for (let j = 0; j < n; j++) {
        if (i === j) {
          matrix[i][j] = { fact: false, dist: 0 } // Расстояние до самого себя = 0
        } else {
          const point1 = selectedPoints[i]
          const point2 = selectedPoints[j]

          // Извлекаем координаты: [longitude, latitude] из ваших данных
          const [lon1, lat1] = point1.coordinates
          const [lon2, lat2] = point2.coordinates

          // Вычисляем расстояние
          matrix[i][j] = { fact: false, dist: this.haversineDistanceM(lat1, lon1, lat2, lon2) }
        }
      }
    }

    return matrix
  }

  calculatePathDistance (path, distanceMatrix) {
    let distance = 0
    for (let i = 0; i < path.length - 1; i++) {
      distance += distanceMatrix[path[i]][path[i + 1]].dist
    }
    return distance
  }

  nearestNeighborAsymmetric (points, distanceMatrix) {
    const n = points.length
    const visited = new Array(n).fill(false)
    visited[0] = true

    const path = [0]
    let current = 0

    for (let step = 0; step < n - 1; step++) {
      let nearest = -1
      let minDist = Infinity

      // Ищем ближайшую НЕПОСЕЩЁННУЮ точку ИЗ текущей
      for (let next = 0; next < n; next++) {
        if (!visited[next] && distanceMatrix[current][next].dist < minDist) {
          minDist = distanceMatrix[current][next]
          nearest = next
        }
      }

      if (nearest === -1) break

      path.push(nearest)
      visited[nearest] = true
      current = nearest
    }

    // Возвращаемся в начальную точку (это тоже асимметрично!)
    path.push(0)
    const totalDistance = this.calculatePathDistance(path, distanceMatrix)

    return {
      method: 'Ближайший сосед (асимметричный)',
      distance: totalDistance,
      path: path
    }
  }

  insertionAsymmetric (points, distanceMatrix, startWith = 'nearest') {
    const n = points.length

    // Начинаем с двух точек
    let path
    if (startWith === 'nearest') {
      // Находим ближайшую к начальной точке
      let nearest = 1
      let minDist = distanceMatrix[0][1].dist
      for (let i = 2; i < n; i++) {
        if (distanceMatrix[0][i].dist < minDist) {
          minDist = distanceMatrix[0][i].dist
          nearest = i
        }
      }
      path = [0, nearest, 0]
    } else {
      // Или начинаем со случайных двух точек
      path = [0, 1, 0]
    }

    const unvisited = new Set()
    for (let i = 0; i < n; i++) {
      if (!path.includes(i)) unvisited.add(i)
    }

    // Последовательно вставляем точки
    while (unvisited.size > 0) {
      let bestPoint = -1
      let bestPosition = -1
      let bestCost = Infinity

      for (const point of unvisited) {
        for (let i = 1; i < path.length; i++) {
          const cost =
            distanceMatrix[path[i - 1]][point].dist +
            distanceMatrix[point][path[i]].dist -
            distanceMatrix[path[i - 1]][path[i]].dist

          if (cost < bestCost) {
            bestCost = cost
            bestPoint = point
            bestPosition = i
          }
        }
      }

      if (bestPoint !== -1) {
        path.splice(bestPosition, 0, bestPoint)
        unvisited.delete(bestPoint)
      } else {
        break
      }
    }

    const totalDistance = this.calculatePathDistance(path, distanceMatrix)

    return {
      method: `Вставка (асимметричная, ${startWith})`,
      distance: totalDistance,
      path: path
    }
  }

  randomStartAsymmetric (points, distanceMatrix, numStarts = 20) {
    const n = points.length
    let bestDistance = Infinity
    let bestPath = null

    for (let attempt = 0; attempt < numStarts; attempt++) {
      let path = [0]
      const otherPoints = []

      for (let i = 1; i < n; i++) otherPoints.push(i)

      // Перемешиваем
      for (let i = otherPoints.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[otherPoints[i], otherPoints[j]] = [otherPoints[j], otherPoints[i]]
      }

      path.push(...otherPoints, 0)
      const distance = this.calculatePathDistance(path, distanceMatrix)

      if (distance < bestDistance) {
        bestDistance = distance
        bestPath = path
      }
    }

    return {
      method: `Случайный старт (${numStarts} попыток)`,
      distance: bestDistance,
      path: bestPath
    }
  }

  async getDistanceMatrix (origins, destinations) {
    const API_KEY = '5ca93d12-4ee5-428f-9125-6f5971ea70cd'
    const baseURL = 'https://api.routing.yandex.net/v2/distancematrix'

    const params = new URLSearchParams({
      origins: this.prepareWaypoints(origins),
      destinations: this.prepareWaypoints(destinations),
      apikey: API_KEY,
      mode: 'truck',
      traffic: 'disabled'
    })

    const url = `${baseURL}?${params.toString()}`

    // try {
    //   const anotherResponse = await sendWithResponse({
    //     type: 'request',
    //     url: url
    //   })
    //   return anotherResponse
    // } catch (error) {
    //   console.error('Ошибка дополнительного запроса:', error)
    // }

    try {
      const response = await fetch(url, {
        method: 'GET'
      })

      if (!response.ok) {
        throw new Error('Response was not ok: ' + response.statusText)
      }

      const data = await response.json()
      return data
    } catch (e) {
      console.error(e)
      return null
    }
  }

  async mainAsymmetricTSPByCoordinates () {
    const iterations = []
    const points = this.selectedPoints
    let bestResult = []

    const distanceMatrix = this.createDistanceMatrix(points)

    const methods = [
      () => this.nearestNeighborAsymmetric(points, distanceMatrix),
      () => this.insertionAsymmetric(points, distanceMatrix, 'nearest'),
      () => this.insertionAsymmetric(points, distanceMatrix, 'random'),
      () => this.randomStartAsymmetric(points, distanceMatrix, 20)
    ]

    for (let iteration = 1; iteration <= 100; iteration++) {
      let results = []

      //Запускаем все методы
      methods.forEach(method => {
        try {
          let startTime = performance.now()
          let result = method()
          let endTime = performance.now()

          result.time = endTime - startTime

          results.push({
            ...result
          })

          // console.log(`${result.method}:`)
          // console.log(`  Расстояние: ${result.distance.toFixed(2)}`)
          // console.log(`  Время: ${result.time.toFixed(2)} мс`)
          // console.log(`  Маршрут: ${result.path.join(' → ')}`)
          // console.log('')
        } catch (error) {
          console.log(`Ошибка в методе: ${error.message}`)
        }
      })

      // Находим лучший результат
      if (results.length <= 0) {
        break
      }

      bestResult = results.reduce((best, current) =>
        current.distance < best.distance ? current : best
      )

      iterations[iteration] = []
      iterations[iteration]['requests'] = 0
      iterations[iteration]['requests_details'] = []
      iterations[iteration]['path'] = [...bestResult.path]
      iterations[iteration]['dist_before_request'] = bestResult.distance
      iterations[iteration]['dist_after_request'] = 0

      let all_fact = true
      let new_value = []

      for (let i = 0; i < bestResult.path.length - 1; i++) {
        if (distanceMatrix[bestResult.path[i]][bestResult.path[i + 1]].fact) {
          iterations[iteration]['dist_after_request'] =
            iterations[iteration]['dist_after_request'] +
            distanceMatrix[bestResult.path[i]][bestResult.path[i + 1]].dist
          continue
        }
        all_fact = false

        let responseData = await this.getDistanceMatrix(
          [points[bestResult.path[i]]],
          [points[bestResult.path[i + 1]]]
        )

        new_value = []
        new_value[String(bestResult.path[i]) + '-' + String(bestResult.path[i + 1])] = {
          before: distanceMatrix[bestResult.path[i]][bestResult.path[i + 1]].dist,
          after: responseData.rows[0].elements[0].distance.value
        }
        iterations[iteration]['requests_details'].push(new_value)

        distanceMatrix[bestResult.path[i]][bestResult.path[i + 1]].dist =
          responseData.rows[0].elements[0].distance.value
        distanceMatrix[bestResult.path[i]][bestResult.path[i + 1]].fact = true

        iterations[iteration]['requests'] = iterations[iteration]['requests'] + 1
        iterations[iteration]['dist_after_request'] =
          iterations[iteration]['dist_after_request'] +
          responseData.rows[0].elements[0].distance.value

        // console.log('=== ЛУЧШИЙ РЕЗУЛЬТАТ ===')
        // console.log(`Метод: ${bestResult.method}`)
        // console.log(`Расстояние: ${bestResult.distance.toFixed(2)}`)
        // console.log(`Маршрут: ${bestResult.path.join(' → ')}`)
      }

      if (all_fact == true) {
        iterations[iteration]['dist_after_request'] = iterations[iteration]['dist_before_request']
        break
      }
    }
    const totalRequests = iterations.reduce((sum, iteration) => sum + iteration.requests, 0)

    console.log('=== РЕЗУЛЬТАТЫ РАСЧЕТА TSP ===')
    console.log(`Всего итераций: ${iterations.length}`)
    console.log(`Всего запросов к API: ${totalRequests}`)
    console.log('')

    if (bestResult) {
      console.log('=== ЛУЧШИЙ РЕЗУЛЬТАТ ===')
      console.log(`Метод: ${bestResult.method}`)
      console.log(`Расстояние: ${bestResult.distance} м`)
      console.log(`Маршрут: ${bestResult.path.join(' → ')}`)
      console.log('')
    }

    // return {
    //   totalRequests: totalRequests,
    //   bestResult: bestResult,
    //   iterations: iterations,
    //   points: points,
    //   distanceMatrix: distanceMatrix
    // }

    const data = []

    bestResult.path.forEach(element => {
      data.push(this.selectedPoints[element])
    })

    const optimalRoute = [...data]

    const responseData = []
    const chunkSize = 49

    while (data.length > 0) {
      const chunk = data.splice(0, chunkSize)
      const response = await getOptimizedPoints(chunk)

      responseData.push(response)
    }

    let route = {
      bestResult: bestResult,
      optimalRoute: optimalRoute,
      totalRequests: totalRequests,
      flags: { ...(responseData[0]?.route?.flags || {}) },
      legs: responseData.reduce((acc, item) => {
        if (Array.isArray(item.route?.legs)) {
          acc.push(...item.route.legs)
        }
        return acc
      }, [])
    }

    return {
      route: route
    }
  }
}
